import { Button, Flex, PanelHeader, Text } from "@coaching-culture/ui";
import React from "react";
import { IconType } from "react-icons";

export type ButtonProps = {
  icon: IconType;
  text: string;
  to?: string;
  onClick?: () => void;
};

/**
 * The title row of a widget card. `icon`, `iconImage` and `iconImageHeight`
 * are still accepted but no longer drawn: card titles are plain text now.
 */
export default function WidgetHeader({
  title,
  button,
}: {
  title: string;
  icon?: IconType;
  iconImage?: string | IconType;
  iconImageHeight?: string;
  button?: ButtonProps;
}) {
  return (
    <PanelHeader
      justifyContent="space-between"
      flexWrap="wrap"
      height="auto"
      minHeight={52}
      style={{ gap: 12 }}
    >
      <Text as="h2" m={0} fontSize="title" fontWeight={600}>
        {title}
      </Text>
      {button != null && button.text != null && (
        <Flex alignItems="center">
          <Button
            small
            to={button.to}
            icon={button.icon}
            onClick={button.onClick !== null ? button.onClick : null}
          >
            {button.text}
          </Button>
        </Flex>
      )}
    </PanelHeader>
  );
}
